import {frontendSettingsApi} from "@App/services/settings/frontendSettingsApi";
import {ITimeTableItem, ITimeTableItemState} from "@App/types";
import { useStyles } from './GPSTrackingTabContent.styles';

type GPSTrackingTimesTabContentProps = {
  selectedEvent: ITimeTableItem,
  selectedEventState: ITimeTableItemState | null,
}

function GPSTrackingTabContent({ selectedEvent, selectedEventState }: GPSTrackingTimesTabContentProps) {
  const classes = useStyles();

  const { data: frontendSettings } = frontendSettingsApi.endpoints.getFrontendSettings.useQueryState('');

  if (!frontendSettings) {
    return null;
  }

  return (
    <div className={classes.root}>
      <iframe title="GPS Tracking" src={`${frontendSettings.gpsTrackingBaseUrl}?id=${selectedEvent.idGPSTracking}&source=cis2`} />
    </div>
  );
}

export default GPSTrackingTabContent;